/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";


export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);

  return (
    <>
      <nav className="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-custom-purple shadow">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <Link
              to="/"
              className="text-white text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
            >
              Startup Name Generator
            </Link>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-custom-purple block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="fas fa-bars text-white"></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-custom-purple lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block" : " hidden")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
              

              <li className="flex items-center">
                <a
                  className="hover:text-white text-white px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://github.com/angelortizv/startup-name-generator"
                  target="_blank"
                >
                  <i className="text-white fab fa-github text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Star on Github</span>
                </a>
              </li>

              <li className="flex items-center">
                <Link
                  to="/favorites"
                  className="hover:text-white text-white px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                >
                  <i className="text-white fas fa-heart text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Favorites</span>
                </Link>
              </li>

            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
